import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { Articulo } from '../models/articulo.model';
import { AuthService } from '../services/auth.service';
import { PedidoService } from './pedido.service';
import { ArticuloService } from './articulo.service';
import { ImagenModel } from '../models/imagen.model';
import { Usuario } from '../models/usuario.model';

@Injectable({
  providedIn: 'root'
})
export class CompraService {


  filtrosShop = environment.FILTROS_SHOP;
  IMG_URL = environment.SERVER_IMG;
  IMG_EXTENSION = environment.IMG_EXTENSION;
  TIPO_BULTO: string;
  COMPRAR_SIN_STOCK: string;
  COMPRA_TB = environment.COMPRA_TB;
  VER_PVP_CAJA = environment.VER_PVP_CAJA;
  VER_PVP_IVA = environment.VER_PVP_IVA;
  MULTI_FOTOS = environment.MULTI_FOTOS;
  VER_REFERENCIA_LOGOUT = environment.VER_REFERENCIA_LOGOUT;
  dia: Date | undefined;
  diaYYYY: string | undefined;
  artYYYY: string | undefined;
  imagenes: Array<ImagenModel> = [];
  imagenPrincipal: string | undefined;
  imagenVer: string | undefined;
  constructor(
    private authService: AuthService,
    private pedidoService: PedidoService,
    private articuloService: ArticuloService,) {
    this.TIPO_BULTO = (this.authService.usuario != null && this.authService.usuario !== undefined) ? this.authService.usuario.tbulto_ver || environment.TIPO_BULTO : environment.TIPO_BULTO;
    this.COMPRAR_SIN_STOCK = (this.authService.usuario != null && this.authService.usuario !== undefined) ? this.authService.usuario.stock || environment.COMPRAR_SIN_STOCK : environment.COMPRAR_SIN_STOCK;
  }

  sePuedeComrar(articulo: Articulo) {
    if (this.authService.isLoggedIn() && (this.COMPRAR_SIN_STOCK !== 'P' || articulo.stock_uni > 0)) {
      return true;
    }
    return false;
  }
  mostrarNoStockTemporal(articulo: Articulo) {
    if (this.authService.isLoggedIn() && (articulo.stock_uni <= 0) && this.COMPRAR_SIN_STOCK === 'P') {
      // if (articulo.referencia === '001003') {
      return true;
    }
    return false;
  }
  calDescuento2(articulo: Articulo) {
    if (articulo.descuento != null && articulo.pvp_sin_iva != null) {
      // const dto = parseFloat(articulo.descuento.replace('-', '').replace(' %', ''));
      // const dto = parseFloat(articulo.descuento);
      return articulo.pvp_sin_iva * ((100 - articulo.descuento) / 100);
    }
    return null;
  }
  calDescuento(articulo: Articulo) {
    if (this.pedidoService.enviando === true) {
      return '';
    }
    if (articulo.pedcl_div_costo_cli === 0) {
      return '';
    }
    if (articulo.pedcl_div_costo_cli !== articulo.pedcl_div_ctocli_dll) {
      return Math.round(100 * (articulo.pedcl_div_costo_cli - articulo.pedcl_div_ctocli_dll) / articulo.pedcl_div_costo_cli);
    }
    return '';
  }
  compraMas(articulo: Articulo) {
    this.pedidoService.sumaCesta(articulo);
  }
  compraMasTb(articulo: Articulo, tb: string) {
    this.tb(articulo, tb, false);
    this.pedidoService.sumaCesta(articulo);
  }
  cambiarCantidad(articulo: Articulo, cant: number) {
    this.pedidoService.cambiarCantidadCesta(articulo, cant);
  }
  compraMenos(articulo: Articulo) {
    this.pedidoService.restaCesta(articulo);
  }
  compraCero(articulo: Articulo) {
    this.pedidoService.borraCesta(articulo);
  }
  lista(articulo: Articulo) {
    this.pedidoService.sumaLista(articulo);
  }
  tb(articulo: Articulo, tb: string, grabar: boolean = true) {
    articulo.pedcl_tb_ped = tb;
    if (tb === 'C') {
      articulo.pedcl_unb_ped = articulo.unid_caja;
    } else if (tb === 'F') {
      articulo.pedcl_unb_ped = articulo.unid_frac;
    } else if (tb === 'U') {
      articulo.pedcl_unb_ped = 1;
    }
    if (grabar) {
      this.pedidoService.tbCesta(articulo);
    }

  }
  etiquetaPvpUnid(articulo: Articulo) {
    if (!this.authService.isLoggedIn()) { return ''; }
    if (!this.VER_PVP_CAJA && !this.VER_PVP_IVA) {
      return 'PVP';
    }
    if (articulo.modo_facturar === 'C' || articulo.art_peso === 'S') {
      return 'PVP Kilo';
    } else if (this.VER_PVP_CAJA) {
      return 'PVP Unid';
    } else {
      return 'PVP'
    }
  }
  etiquetaPvpCaja() {
    if (!this.authService.isLoggedIn()) { return ''; }
    localStorage.setItem('CAJA', this.VER_PVP_CAJA ? 'SI' : 'NO')
    localStorage.setItem('CAJA2', environment.VER_PVP_CAJA ? 'SI' : 'NO')
    if (this.VER_PVP_CAJA) {

      return 'PVP Caja';
    } else if (this.VER_PVP_IVA) {
      return `PVP ${this.authService.usuario != null ? this.authService.usuario.timp_titulo : 'IVA'}`;
    }
    return '';
  }
  etiquetaDto(articulo: Articulo) {
    if (articulo.pedcl_pedcl_id == null && articulo.descuento !== null && articulo.descuento !== 0
      && articulo.pvp_of_sin_iva == null) {
      return 'Dto';
    } else if (articulo.pedcl_pedcl_id != null && articulo.pedcl_div_costo_cli !== articulo.pedcl_div_ctocli_dll && articulo) {
      return 'Dto';
    } else {
      return '';
    }
  }
  classPvpUnid(articulo: Articulo) {
    if (articulo.pvp_esp !== null) {
      return 'pvp-especial';
    } else if (articulo.pvp_of_sin_iva !== null) {
      return 'pvp-oferta';
    }

    return 'pvp-normal';
  }
  classSelUnid(articulo: Articulo) {
    switch (articulo.pedcl_tb_ped) {
      case 'U':
        return 'btn-unid';
      case 'F':
        return 'btn-frac';
      case 'C':
        return 'btn-caja';
      case 'K':
        return 'btn-kilo';

      default:
        return 'btn-unid';
    }
  }
  valorPvpUnid(articulo: Articulo) {
    if (articulo.pvp_esp !== null) {
      return articulo.pvp_esp;
    } else if (articulo.pvp_of_sin_iva !== null) {
      if (this.authService.usuario != null && this.authService.usuario.impuestos) {
        return articulo.pvp_of_con_iva;
      } else {
        return articulo.pvp_of_sin_iva;
      }
    } else {
      if (this.authService.usuario != null && this.authService.usuario.impuestos) {
        return articulo.pvp_con_iva;
      } else {
        return articulo.pvp_sin_iva;
      }
    }
  }
  valorPvpCaja(articulo: Articulo) {
    if (articulo.pvp_esp !== null) {
      return articulo.pvp_esp;
    } else if (articulo.pvp_of_sin_iva !== null) {
      if (this.authService.usuario != null && this.authService.usuario.impuestos) {
        return articulo.pvp_of_con_iva;
      } else {
        return articulo.pvp_of_sin_iva;
      }
    } else if (this.VER_PVP_CAJA) {
      if (articulo.pvp_esp == null && articulo.pvp_of_sin_iva == null
        && articulo.pvp_sin_iva !== articulo.pvp_caja_sin_iva) {
        if (this.authService.usuario != null && this.authService.usuario.impuestos) {
          return articulo.pvp_caja_con_iva;
        } else {
          return articulo.pvp_caja_sin_iva;
        }
      }
      // si no hay precio caja, mostrar precio unidad
      return this.valorPvpUnid(articulo);
    } else if (this.VER_PVP_IVA) {
      if (articulo.pvp_of_sin_iva !== null) {
        return articulo.pvp_of_sin_iva;
      } else if (articulo.pvp_esp == null) {
        if (this.authService.usuario != null && this.authService.usuario.impuestos) {
          return articulo.pvp_sin_iva;
        } else {
          return articulo.pvp_con_iva;
        }
      }
    } else if (!this.VER_PVP_CAJA && !this.VER_PVP_IVA) {
      if (articulo.pvp_esp == null && articulo.pvp_of_sin_iva == null
        && articulo.pvp_sin_iva !== articulo.pvp_caja_sin_iva) {
        if (this.authService.usuario != null && this.authService.usuario.impuestos) {
          return articulo.pvp_caja_con_iva;
        } else {
          return articulo.pvp_caja_sin_iva;
        }
      }
      // si no hay precio caja, mostrar precio unidad
      return this.valorPvpUnid(articulo);
    }
    return null;
  }
  classPvpCaja(articulo: Articulo) {
    if (articulo.pvp_esp !== null) {
      return 'pvp-especial';
    } else if (articulo.pvp_of_sin_iva !== null) {
      return 'pvp-oferta';
    }

    return 'pvp-caja';
  }
  valorDto(articulo: Articulo) {
    if (articulo.pedcl_pedcl_id == null && articulo.descuento !== null && articulo.descuento !== 0
      && articulo.pvp_of_sin_iva == null) {
      return articulo.descuento;
    } else if (articulo.pedcl_pedcl_id != null && articulo.pedcl_div_costo_cli !== articulo.pedcl_div_ctocli_dll) {
      return this.calDescuento(articulo);
    } else {
      return '';
    }
  }
  verLogisticaInfo(articulo: Articulo) {
    if (articulo.bulto_pvp === 'F') {
      return `Caja ${articulo.unid_caja / articulo.unid_frac}`;
    } else if (articulo.bulto_pvp === 'U') {
      if (articulo.unid_frac !== articulo.unid_caja && articulo.unid_frac != 1) {
        return `Caja ${articulo.unid_caja} Frac ${articulo.unid_frac}`;
      } else {
        return `Caja ${articulo.unid_caja}`;
      }
    }
    return 'Caja ';
  }
  valorReferencia(articulo: Articulo) {
    if (articulo.referencia.length > 8) {
      return articulo.referencia.replace(/\b0+/g, '');
    }
    return articulo.referencia;
  }
  /**
  * Precio caja independiente de la visualización
  */
  artPvpCaja(articulo: Articulo) {
    if (articulo.pvp_esp !== null) {
      return articulo.pvp_esp;
    } else if (articulo.pvp_of_sin_iva !== null) {
      if (this.authService.usuario != null && this.authService.usuario.impuestos) {
        return articulo.pvp_of_con_iva;
      } else {
        return articulo.pvp_of_sin_iva;
      }
    } else
      if (this.authService.usuario != null && this.authService.usuario.impuestos) {
        return articulo.pvp_caja_con_iva ?? articulo.pvp_con_iva;
      } else {
        return articulo.pvp_caja_sin_iva ?? articulo.pvp_sin_iva;
      }

  }
  /**
  * Precio unid independiente de la visualización
  */
  artPvpUnid(articulo: Articulo) {
    if (articulo.pvp_esp !== null) {
      return articulo.pvp_esp;
    } else if (articulo.pvp_of_sin_iva !== null) {
      if (this.authService.usuario != null && this.authService.usuario.impuestos) {
        return articulo.pvp_of_con_iva;
      } else {
        return articulo.pvp_of_sin_iva;
      }
    } else {
      if (this.authService.usuario != null && this.authService.usuario.impuestos) {
        return articulo.pvp_con_iva ?? articulo.pvp_caja_con_iva;
      } else {
        return articulo.pvp_sin_iva ?? articulo.pvp_caja_sin_iva;
      }
    }
  }
  mostrarUnidButton(articulo: Articulo): boolean {

    if (!this.authService.isLoggedIn()) return false;
    if (!articulo) return false;

    // ⬇️ A partir de aquí, SOLO si articulo.permite_unid === 'N'

    const { unid_caja, unid_frac } = articulo;

    let usuario: Usuario = this.authService.usuario!;
    const permiteCli = usuario.permite_unid ?? 'S';
    if (this.TIPO_BULTO.indexOf('U') == -1) return false;
    if (permiteCli === 'N') return false;
    if (unid_caja === 1) return false;

    const cajaEqFrac = unid_caja === unid_frac;
    const cajaNotEqFrac = !cajaEqFrac;

    if (cajaEqFrac) {
      if (permiteCli === 'S') {
        return true;
      } else if (permiteCli === 'F') {
        return articulo.permite_unid === 'S';
      }
    }

    if (cajaNotEqFrac) {
      if (unid_frac == 1) return false;
      return permiteCli === 'S';
    }

    return false;
  }


  mostrarFracButton(articulo: Articulo): boolean {
    let usuario: Usuario = this.authService.usuario!;
    const permiteCli = usuario.permite_unid ?? 'S';

    if (this.TIPO_BULTO.indexOf('F') == -1) return false;
    if (!this.authService.isLoggedIn()) return false;
    if (!articulo) return false;
    if (this.mostrarUnidButton(articulo)) return false;

    const { unid_caja, unid_frac } = articulo;

    if (unid_caja === 1) return false;

    const cajaEqFrac = unid_caja === unid_frac;
    if (cajaEqFrac) return false;

    // caja ≠ fracción
    return true;
  }

}
